export default __webpack_public_path__ + "static/map_marker_A-8d44433aaa7bd09ef42fcf654c46bd7d.png";